import ClientLayout from "../../components/Layout/ClientLayout";
import AboutUsImage from "../../assets/images/AboutUs.jpg";
import Avatar from "../../assets/images/avatar.jpg";
import Avatar2 from "../../assets/images/Avatar2.png";
import Avatar3 from "../../assets/images/Avatar3.png";

import { IoLogoInstagram } from "react-icons/io";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import Button, { BUTTON_TYPE_CLASSES } from "../../components/button/button.component";

const AboutUs = () => {
  const handleSendEmail = () => {
    const to = "info@mambahikers.com";
    const subject = encodeURIComponent("Hello from My App");
    const body = encodeURIComponent(
      "Hi there,\n\nI wanted to reach out to you..."
    );

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}`;

    window.open(gmailUrl, "_blank");
  };
  return (
    <ClientLayout>
      <div className="px-5">
        {/* HERO COMPONENT */}
        <div className="bg-about-us h-[300px] bg-cover bg-center rounded-lg relative w-full">
          <div class="absolute inset-0 bg-color-primary-dark2 opacity-20"></div>
          <div className="text-5xl font-bold text-white z-100 flex justify-center items-center h-full">
            About Us
          </div>
        </div>

        <div className="px-8 lg:px-28 py-10 lg:py-20">
          <div className="flex flex-col md:flex-row md:space-x-10 space-y-6 md:space-y-0 w-full">
            <div className="md:flex-[1.5]">
              <div className="font-bold text-3xl md:text-5xl my-4 md:my-8">
                Our Story
              </div>

              <div className="text-xl md:text-4xl">
                At Mamba Hikers, we're not just about conquering peaks; we're
                about conquering yourself. Every summit we reach is a step
                towards rediscovering the wild spirit within. We're a tribe of
                adventure seekers, united by the rhythm of boots on dirt and the
                thrill of pushing beyond our limits.
              </div>

              <div className="text-xl md:text-4xl mt-8">
                Our journey began with a simple yet powerful belief that every
                individual, regardless of their hiking experience, possesses an
                innate ability to conquer the most challenging peak. Mamba
                Hikers is more than a brand; it's a movement that invites
                everyone, from seasoned trekkers to first-time explorers, to
                embrace the thrill of the trail. Our experienced guides are not
                just experts in navigating trails; they are mentors in
                self-discovery. Discover the world beyond the ordinary with
                Mamba Hikers — where the toughest mountains become the most
                rewarding milestones on your hiking journey.
              </div>

              <div className="font-bold my-8">Our Socials</div>
              <div className="flex space-x-8 mb-10">
                <div>
                  <a
                    href="https://www.instagram.com/mambahikers?igsh=MWNwZXQweDd6ODdoZg=="
                    target="_blank"
                  >
                    <IoLogoInstagram size={35} color="#ee2a7b" />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.facebook.com/mambahikers"
                    target="_blank"
                  >
                    <FaFacebookF size={35} color="#1877f2" />
                  </a>
                </div>
                <div>
                  <a
                    href="https://x.com/Mambahikers?t=zN1p261-8xzi5ERoSEFNoA&s=09"
                    target="_blank"
                  >
                    <FaTwitter size={35} color="#1da1f2" />
                  </a>
                </div>
              </div>
            </div>

            <div className="md:flex-1">
              <img
                src={AboutUsImage}
                alt=""
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>
          </div>

          {/* <div className="my-28">
            <div className="font-bold text-6xl text-center my-10">
              Begin Your Adventure with Us
            </div>

            <div className="flex space-x-5 flex-wrap space-y-5 justify-center">
              <div className="px-10 py-5 border-[3px]">
                <div className="w-28">
                  <img src={Avatar3} alt="" className="w-full h-auto" />
                </div>

                <div className="font-semibold">John Doe</div>
                <div>Sem eu senectus ridiculus nam fames nisl natoque</div>
              </div>

              <div className="px-10 py-5 border-[3px]">
                <div className="w-28">
                  <img src={Avatar} alt="" className="w-full h-auto" />
                </div>

                <div className="font-semibold">John Doe</div>
                <div>Sem eu senectus ridiculus nam fames nisl natoque</div>
              </div>

              <div className="px-10 py-5 border-[3px]">
                <div className="w-28">
                  <img src={Avatar2} alt="" className="w-full h-auto" />
                </div>

                <div className="font-semibold">John Doe</div>
                <div>Sem eu senectus ridiculus nam fames nisl natoque</div>
              </div>

              <div className="px-10 py-5 border-[3px]">
                <div className="w-28">
                  <img src={Avatar} alt="" className="w-full h-auto" />
                </div>

                <div className="font-semibold">John Doe</div>
                <div>Sem eu senectus ridiculus nam fames nisl natoque</div>
              </div>
            </div>
          </div> */}

          {/* TESTIMONIALS SECTION */}
          <div className="my-28">
            <div className="font-bold text-6xl text-center mb-10">
              What Our Clients Say
            </div>

            <div className="flex flex-wrap justify-center gap-10">
              {/* Testimonial Card */}
              <div className="max-w-xl p-8 border-[3px] rounded-lg shadow-sm bg-white">
                <div className="flex items-center space-x-4 mb-4">
                  <img
                    src={Avatar}
                    alt="Client"
                    className="w-16 h-16 rounded-full"
                  />
                  <div>
                    <div className="font-semibold text-lg">Jane Wanjiku</div>
                    <div className="text-sm text-gray-500">Adventurer</div>
                  </div>
                </div>
                <div className="text-gray-700 leading-relaxed">
                  “Traveling with this team was the best decision I ever made.
                  Everything was seamless, and I got to explore places I never
                  imagined.”
                </div>
              </div>

              <div className="max-w-xl p-8 border-[3px] rounded-lg shadow-sm bg-white">
                <div className="flex items-center space-x-4 mb-4">
                  <img
                    src={Avatar2}
                    alt="Client"
                    className="w-16 h-16 rounded-full"
                  />
                  <div>
                    <div className="font-semibold text-lg">Ali Omondi</div>
                    <div className="text-sm text-gray-500">Backpacker</div>
                  </div>
                </div>
                <div className="text-gray-700 leading-relaxed">
                  “I loved how personal and tailored the experience was.
                  Definitely recommending to my friends.”
                </div>
              </div>

              <div className="max-w-xl p-8 border-[3px] rounded-lg shadow-sm bg-white">
                <div className="flex items-center space-x-4 mb-4">
                  <img
                    src={Avatar3}
                    alt="Client"
                    className="w-16 h-16 rounded-full"
                  />
                  <div>
                    <div className="font-semibold text-lg">Sarah Mutheu</div>
                    <div className="text-sm text-gray-500">Solo Traveler</div>
                  </div>
                </div>
                <div className="text-gray-700 leading-relaxed">
                  “From planning to the actual trip, they handled everything. I
                  just relaxed and enjoyed. Can’t wait for my next adventure!”
                </div>
              </div>
            </div>
          </div>

          <section className="relative min-h-[30vh]  lg:min-h-[35vh]  max-h-max bg-call-to-action2 bg-cover bg-bottom bg-fixed">
            <div className="absolute inset-0 bg-color-primary-dark1 opacity-30"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90vw] lg:w-[60vw] flex flex-col md:flex-row justify-between items-center text-white text-center p-12">
              <div className="">
                <div className="text-[2.5rem] font-bold">
                  We offer private hiking events
                </div>
                <div>Please Contact us For more information</div>
              </div>
              <div>
                <Button
                  buttonType={BUTTON_TYPE_CLASSES.inverted}
                  onClick={handleSendEmail}
                >
                  Contact Us
                </Button>
              </div>
            </div>
          </section>

          <div style={{ width: "100%", height: "350px" }} className="my-20">
            <div className="font-bold text-6xl text-center mb-5">
              Our Location
            </div>
            <div className="text-center mb-16 italic font-semibold">
              J's Arcade, Thome Outlet Number J28
            </div>
            <iframe
              title="Google Map - J's Arcade"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.900123851412!2d36.870514799999995!3d-1.2292414999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f15c08c4f72e3%3A0xa9a7571c449c0657!2sJ's%20Arcade!5e0!3m2!1sen!2ske!4v1746636715200!5m2!1sen!2ske"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default AboutUs;
